// extracted by mini-css-extract-plugin
export default {"physicalScratcher":"PhysicalScratcher_physicalScratcher__LPBiB"};